import { SHHtmlBlock, SHStack } from "@components/design-systems";
import { useTheme } from "@mui/material";
import { ReadMoreButton } from "@pages/suppliers/_id/_products/investment-product/_id/view/components/view-feature-model/components/read-more";
import React, { useEffect, useRef, useState } from "react";
interface ExpandableHtmlBlockProps {
  value: string;
  fieldType?: string;
}

const ExpandableHtmlBlock: React.FC<ExpandableHtmlBlockProps> = ({
  value,
  fieldType,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { palette } = useTheme();

  const checkOverflow = () => {
    if (contentRef.current) {
      setIsOverflowing(contentRef.current.scrollHeight > 85);
    }
  };

  useEffect(() => {
    if (!value) return;
    checkOverflow();
    // eslint-disable-next-line
  }, [contentRef.current, value]);

  return (
    <>
      <SHStack
        ref={contentRef}
        sx={{
          maxHeight: "85px",
          overflow: "hidden",
          color: palette.text.fourth,
          fontWeight: 500,
          fontSize: "0.813rem",
          fontFamily: "Epilogue",
        }}
      >
        <SHHtmlBlock
          variant="body3"
          textAlign={"left"}
          content={value}
          sx={{
            "& p, ul, li, ol": {
              display: "inline-table",
              wordBreak: "break-word",
            },
          }}
        />
      </SHStack>

      {isOverflowing && (
        <ReadMoreButton content={value} fieldType={fieldType} />
      )}
    </>
  );
};

export default ExpandableHtmlBlock;
